
import { IdfButton } from '@invivodf/ui-kit'
import { computed, defineComponent } from 'vue'
import { DiscountRouteName } from '../routes/discountRouteName'

export default defineComponent({
  name: 'CDiscountDetailHeaderLinkButtonDuplicate',
  components: { IdfButton },
  props: {
    id: {
      type: String,
      required: true,
    },
    discountPolicyId: {
      type: String,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const route = computed(() => {
      return {
        name: DiscountRouteName.DUPLICATE,
        params: { discountId: props.id, discountPolicyId: props.discountPolicyId },
        query: { active: props.isActive.toString() },
      }
    })

    return { route }
  },
})
